<template>
  <footer class="builder-footer pa-4">

    <nav class="footer-actions">

      <Btn class="outline light--border mr-3" color="bb-primary" width="40" height="40" aria-label="Start a new build" title="Start a new build" @click="$emit('reset')" icon>
        <v-icon v-text="'mdi-restore'"/>
      </Btn>

      <Btn class="outline light--border mr-3" color="bb-primary" width="40" height="40" @click="$emit('share')" icon>
        <v-icon v-text="'mdi-share-variant'"/>
      </Btn>

      <Btn
        class="outline light--border"
        href="https://web.whatsapp.com/send?phone=34652923272&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20que%20me%20ayudaras%20con...."
        width="40" height="40"
        title="¿Cómo puedo ayudarte?"
        color="bb-primary"
        target="_blank"
        icon
      >
        <v-icon v-text="'mdi-whatsapp'"/>
      </Btn>

    </nav>

    <v-spacer class="footer-spacer"/>

    <div v-if="weight" class="footer-weight">
      <ClimbTimes class="footer-climbs" :setup="climbSetup" :reference="climbReference"/>
      <WeightEstimate :weight="weight"/>
    </div>

    <Price
      class="footer-srp"
      align="right"
      :price="price"
      :offer="specialBuild && specialBuild.price"
    />

    <Btn class="footer-overview body-1" color="bb-primary" @click="$emit('details')" height="40" tile dark>
      <v-icon left v-text="'mdi-magnify'"/>
      <span class="footer-overview-long">View build overview</span><span class="footer-overview-short">Overview</span>
    </Btn>

    <Btn class="footer-enquire body-1" color="bb-secondary" @click="$emit('form')" height="40" tile dark>
      <v-icon left v-text="'mdi-bookmark-outline'"/>
      Save the build
    </Btn>

  </footer>
</template>

<script>

  import { Btn, Price } from '@/components';
  import WeightEstimate from './WeightEstimate';
  import ClimbTimes from './ClimbTimes';

  export default {
    components: { Btn, Price, WeightEstimate, ClimbTimes },
    props: {
      specialBuild: Object,
      weight: Object,
      climbSetup: Object,
      climbReference: Object,
      price: {
        type: Number,
        default: 0
      }
    }
  }
</script>

<style>
  .footer-overview-short { display: none; }

  .builder-footer {
    display: -webkit-flex;
    display: flex;
  }
  .footer-srp {
    margin-right: 16px;
  }
  .footer-weight {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-shrink: 0;
    margin-right: 20px;
    padding-right: 20px;
    border-right: 1px solid var(--builder-line, #dedfd7);
  }
  .detail-image {
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: contain;
  }
  .detail-price {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .footer-overview {
    margin-right: 8px;
  }
  @media ( max-width: 1160px ) {
    .builder-footer {
      display: block;
      border-top: 1px solid var(--v-light-base);
    }
    .footer-details, .footer-actions {
      float: left;
    }
    .footer-left, .footer-right {
      max-width: 350px;
      margin: 0 auto;
    }
    .footer-srp {
      float: right;
      text-align: left;
      margin: 8px 0;
    }
    .footer-srp > p {
      display: inline-block;
    }
    .footer-srp > p.caption {
      font-size: 1rem !important;
      margin-right: 10px;
    }
    .footer-srp > p.display-4 {
      font-size: 1.5rem !important;
    }
    .footer-enquire, .footer-overview {
      margin-top: 8px;
      width: 100%;
    }
  }
  @media ( max-width: 1024px ) {
    .builder-footer {
      display: -webkit-flex;
      display: flex;
    }
    .footer-srp {
      float: none;
      margin-right: 16px;
    }
    .footer-enquire, .footer-overview {
      margin-top: 0;
      width: auto;
    }
  }
  @media ( max-width: 760px ) {
    .builder-footer {
      display: block;
    }
    .footer-srp {
      float: right;
      text-align: left;
      margin: 8px 0;
    }
    .footer-enquire, .footer-overview {
      margin-top: 8px;
      width: 100%;
    }
  }
  @media ( max-width: 540px ) {
    .builder-footer {
      text-align: right;
      padding: 8px 12px !important;
    }
    .footer-weight {
      gap: 6px;
    }
  }
  @media ( max-width: 400px ) {
    .footer-weight {
      margin-right: 10px;
      padding-right: 10px;
    }
    .footer-details {
      width: 100%;
      margin-bottom: 8px;
    }
    .footer-srp {
      float: none;
      display: inline-block;
    }
    /* Overview + enquire side by side, compact */
    .builder-footer .footer-overview,
    .builder-footer .footer-enquire {
      width: calc(50% - 5px) !important;
      min-width: 0 !important;
      margin-top: 8px;
      padding: 0 4px !important;
      font-size: .72rem !important;
    }
    .builder-footer .footer-overview {
      margin-right: 8px;
    }
    .footer-overview .v-icon, .footer-enquire .v-icon {
      font-size: 16px !important;
    }
    /* No price bar before anything is selected (matches bespoke's home) */
    .builder-initial .builder-footer {
      display: none;
    }
  }
</style>
